module.exports = __webpack_public_path__ + "img/giropay.ab5518b1.svg";